export enum ContentType {
  APPLICATION_PDF = 'application/pdf',
  TEXT_CSV = 'text/csv',
}
